import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { Link } from "react-router-dom";
import "./Helpchat.css";
import Contact from "./Contact";

const HousePartySupport = () => {
  const [openCollapse, setOpenCollapse] = useState({
    open1: false,
    open2: false,
    open3: false,
    open4: false,
    open5: false,
  });
  const handleCollapseToggle = (collapseKey) => {
    setOpenCollapse((prevState) => ({
      ...Object.keys(prevState).reduce((acc, key) => {
        acc[key] = key === collapseKey ? !prevState[key] : false;
        return acc;
      }, {}),
    }));
  };
  return (
    <div className="ps-2">
      <div>
        <p style={{ color: "blue", fontWeight: "500" }}>
          नमस्कार, हम यहां आपकी मदद के लिए हैं।
        </p>
        <p style={{ color: "#ff5c09" }}>सुझाव:</p>
        <ul style={{ fontSize: "12px", lineHeight: "20px" }}>
          <li>
            अपनी प्रोफ़ाइल अपडेट करें और उसे 100% पूरा करें: अपनी प्रोफ़ाइल पूरी
            तरह से अपडेट करें, जिसमें आपका स्थान, विशेषज्ञता, व्यंजन, उपलब्धता
            और कोई खास रीक्वारेमेंटएं शामिल हों। इससे घर के ग्राहकों को आपके
            बारे में बेहतर समझने में मदद मिलेगी।
          </li>
          <li>
            नियमित रूप से आवेदनों की जांच करें: जितनी बार हो सके आवेदनों की जांच
            करें। जल्दी संपर्क करने से आप अन्य रसोइयों को पछाड़ सकते हैं। आपकी
            प्रोफ़ाइल को भी अधिक दिखावट मिलेगी, जिससे आपको अधिक हॉउस कुक
            नौकरियों की पेशकश या पार्टी ऑर्डर मिल सकते हैं।
          </li>
          <li>
            आपके निकट के मिलते-जुलते हॉउस कुक नौकरियों को सहेजें और उनसे संपर्क
            करें: जब आप हॉउस कुक नौकरियों को खोजते हैं, तो उन नौकरियों को सहेजें
            जो आपकी विशेषज्ञता और उपलब्धता से मेल खाती हों। जल्दी संपर्क करके आप
            उन्हें किसी और को पकड़ने से पहले सुरक्षित कर सकते हैं।
          </li>
          <li>
            केवल उन्हीं नौकरियों या इवेंट्स के लिए आवेदन करें जो आपकी विशेषज्ञता
            और उपलब्धता से मेल खाते हों: अपना समय और प्रयास बचाने और प्रासंगिक
            अवसरों से अधिक प्रतिक्रियाएँ प्राप्त करने के लिए, केवल उन्हीं
            नौकरियों या इवेंट्स के लिए आवेदन करें जो आपकी प्रोफ़ाइल से मेल खाते
            हों।
          </li>
        </ul>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open1")}
          aria-controls="example-fade-text"
          aria-expanded={openCollapse.open1}
          className="help"
        >
          प्रोफ़ाइल
        </p>
        <Collapse in={openCollapse.open1}>
          <div id="example-fade-text">
            <p style={{ fontSize: "12px" }}>
              अपनी प्रोफ़ाइल को अपडेट करें ताकि क्लाइंट्स आपको ढूंढ सकें और आपसे
              संपर्क कर सकें।
            </p>
            <Link
              to="/cook/edit-cook-profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              बेसिक प्रोफ़ाइल अपडेट करें
            </Link>
            <Link
              to="/cook/edit-house-profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              हॉउस कुक प्रोफ़ाइल अपडेट करें
            </Link>
            <Link
              to="/cook/edit-party-profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              पार्टी प्रोफ़ाइल अपडेट करें
            </Link>
            <Link
              to="/cook/edit-cook-profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              डीपी अपडेट करें
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open2")}
          aria-controls="example-fade-text1"
          aria-expanded={openCollapse.open2}
          className="mt-3 help"
        >
          हॉउस कुक नौकरियां
        </p>
        <Collapse in={openCollapse.open2}>
          <div id="example-fade-text1">
            <p style={{ fontSize: "12px" }}>
              क्लाइंट्स को रुचि भेजें और उनसे संपर्क करें: अपना आवेदन जल्दी
              मंजूर कराने के लिए, उन क्लाइंट्स को सीधे अपनी रुचि भेजें जो आपके
              प्रोफाइल से मेल खाते हों और उनसे संपर्क करें।
            </p>
            <Link
              to="/cook/housejobs"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              हॉउस कुक नौकरियां खोजें
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open3")}
          aria-controls="example-fade-text2"
          aria-expanded={openCollapse.open3}
          className="mt-3 help"
        >
          इवेंट्स
        </p>
        <Collapse in={openCollapse.open3}>
          <div id="example-fade-text2">
            <p style={{ fontSize: "12px" }}>
              क्लाइंट्स को रुचि भेजें और उनसे संपर्क करें: अपना आवेदन जल्दी
              मंजूर कराने के लिए, उन क्लाइंट्स को सीधे अपनी रुचि भेजें जो आपके
              प्रोफाइल से मेल खाते हों और उनसे संपर्क करें।
            </p>
            <Link
              to="/cook/find-events"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              इवेंट्स खोजें
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open4")}
          aria-controls="example-fade-text3"
          aria-expanded={openCollapse.open4}
          className="mt-3 help"
        >
          संपर्क सेटिंग्स
        </p>
        <Collapse in={openCollapse.open4}>
          <div id="example-fade-text3">
            <Link
              to="/cook/profile"
              style={{
                display: "block",

                fontSize: "14px",
              }}
            >
              व्हाट्सऐप जोड़ें
            </Link>
            <Link
              to="/cook/profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              मोबाइल नंबर बदलें
            </Link>
            <Link
              to="/cook/profile"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              ईमेल बदलें
            </Link>
            <Link
              to="/cook/settings"
              style={{
                display: "block",
                marginTop: "8px",
                fontSize: "14px",
              }}
            >
              संपर्क गोपनीयता
            </Link>
          </div>
        </Collapse>

        <p
          style={{ fontSize: "14px", fontWeight: "500" }}
          onClick={() => handleCollapseToggle("open5")}
          aria-controls="example-fade-text4"
          aria-expanded={openCollapse.open5}
          className="mt-3 help"
        >
          हमसे संपर्क करें
        </p>
        <Collapse in={openCollapse.open5}>
          <div id="example-fade-text4">
            <Contact />
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default HousePartySupport;
